"use client";

import Link from "next/link";
import { CompanyInfo } from "@/components/legal/CompanyInfo";

const EFFECTIVE_DATE = "2026-05-30";

const ARTICLES: { heading: string; body: string[] }[] = [
  {
    heading: "제1조 (목적)",
    body: [
      "이 약관은 트렌드레인(이하 '회사')이 제공하는 카페·외식 트렌드 정보 SaaS 서비스(이하 '서비스')의 이용과 관련하여 회사와 이용자 사이의 권리·의무 및 책임사항, 기타 필요한 사항을 규정함을 목적으로 합니다.",
    ],
  },
  {
    heading: "제2조 (용어의 정의)",
    body: [
      "① '서비스'란 회사가 운영하는 웹사이트 및 모바일 웹을 통해 제공하는 트렌드 키워드 정보, 레시피 연동, 제조업체 디렉토리, 커뮤니티, 지도 시각화, AI 검색·판단 요약 기능 등 일체의 서비스를 의미합니다.",
      "② '이용자'란 이 약관에 따라 회사가 제공하는 서비스를 받는 회원 및 비회원을 말합니다.",
      "③ '회원'이란 카카오 등 소셜 로그인을 통해 서비스에 가입한 자로서, 회사가 제공하는 티어별 기능을 이용할 수 있는 자를 말합니다.",
      "④ '티어'란 이용자의 권한 범위를 구분하는 등급(무료 공개 / 무료 인증 / 유료 / 프랜차이즈)을 의미합니다.",
    ],
  },
  {
    heading: "제3조 (약관의 효력 및 변경)",
    body: [
      "① 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 이용자에게 공지함으로써 효력이 발생합니다.",
      "② 회사는 관련 법령을 위배하지 않는 범위에서 이 약관을 변경할 수 있으며, 변경 시 적용일자 및 변경사유를 명시하여 최소 7일 이전부터 서비스 내에 공지합니다. 이용자에게 불리한 변경의 경우 30일 이전부터 공지합니다.",
      "③ 변경 공지 후 이용자가 탈퇴 의사를 표시하지 않고 서비스를 계속 이용하는 경우 변경된 약관에 동의한 것으로 봅니다.",
    ],
  },
  {
    heading: "제4조 (회원가입 및 해지)",
    body: [
      "① 회원가입은 이용자가 소셜 로그인(카카오 등)을 통해 약관 및 개인정보처리방침에 동의함으로써 체결됩니다.",
      "② 회사는 아래 각 호에 해당하는 경우 가입을 거절하거나 사후 해지할 수 있습니다.",
      "  1. 타인의 명의나 정보를 도용한 경우",
      "  2. 허위 정보를 기재한 경우",
      "  3. 이전에 회원자격을 상실한 이력이 있는 경우",
      "  4. 기타 이 약관에 위배되거나 위법·부당한 이용신청임이 확인된 경우",
      "③ 회원은 언제든지 마이페이지를 통해 회원탈퇴를 요청할 수 있으며, 회사는 관련 법령이 정하는 바에 따라 이를 처리합니다.",
    ],
  },
  {
    heading: "제5조 (회원의 의무)",
    body: [
      "① 회원은 본인의 계정 및 비밀번호(소셜 계정 포함) 관리에 대한 책임을 부담하며, 타인에게 이용을 허락해서는 안 됩니다.",
      "② 회원은 서비스 이용 시 다음 각 호의 행위를 해서는 안 됩니다.",
      "  1. 서비스에 게시된 정보를 임의로 복제, 변경, 상업적으로 재배포하는 행위",
      "  2. 서비스의 안정적 운영을 방해하는 행위(과도한 자동화 요청, 크롤링, 해킹 등)",
      "  3. 커뮤니티에 스팸, 광고, 음란·폭력·혐오 표현, 허위사실을 게시하는 행위",
      "  4. 타인의 지적재산권, 명예, 개인정보 등 권리를 침해하는 행위",
      "  5. 기타 관련 법령 및 이 약관에 위배되는 행위",
      "③ 신고 누적 3건 이상인 커뮤니티 게시물은 자동으로 숨김 처리되며, 관리자의 검토 후 삭제 또는 복원됩니다.",
    ],
  },
  {
    heading: "제6조 (서비스의 제공 및 변경)",
    body: [
      "① 회사는 다음의 서비스를 제공합니다.",
      "  1. 트렌드 키워드 수집·정제·분류 및 시각화",
      "  2. 레시피·지역 분포·제조업체 정보 연계",
      "  3. 커뮤니티(글쓰기·댓글·좋아요·신고)",
      "  4. AI 기반 자연어 검색 및 AI 판단 요약",
      "  5. 알림 서비스(카카오톡·이메일·텔레그램)",
      "  6. 기타 회사가 정하는 업무",
      "② 회사는 서비스의 품질 향상을 위해 서비스의 내용, 구성, UI 등을 언제든지 변경할 수 있으며, 변경 시 중요 사항은 사전 공지합니다.",
      "③ 회사는 시스템 점검, 보수, 정전, 천재지변, 제3자 서비스(카카오·네이버·OpenAI 등) 장애 등 불가피한 사유 발생 시 서비스 제공을 일시 중단할 수 있습니다.",
    ],
  },
  {
    heading: "제7조 (유료 서비스 이용 및 결제)",
    body: [
      "① 유료·프랜차이즈 등 유료 티어는 월 단위 구독 방식 (정기결제) 으로 제공되며, 회사가 지정한 PG사 (토스페이먼츠) 를 통해 매월 자동 결제됩니다.",
      "② 정기결제는 결제 즉시 서비스 제공이 개시되며, 디지털 콘텐츠의 특성상 「전자상거래 등에서의 소비자보호에 관한 법률」 제17조 제2항 제5호에 따라 청약철회가 제한됩니다.",
      "③ 회원은 마이페이지에서 언제든 '자동 갱신 해지' 를 할 수 있으며, 해지 시 다음 결제일부터 과금되지 않습니다. 이미 결제된 당월 서비스는 만료일까지 그대로 유지됩니다.",
      "④ 다음 각 호의 예외 케이스에 한해 환불 신청이 가능하며, 1:1 문의를 통해 접수받아 회사가 검토 후 처리합니다:",
      "   가. 동일 회차 이중 결제 (시스템 오류)",
      "   나. 회원 본인이 아닌 제3자의 무단 결제 (도용·해킹)",
      "   다. 회사 귀책 사유로 서비스를 전혀 이용할 수 없었던 경우",
      "⑤ 정기결제가 연속 3회 실패할 경우 자동으로 구독이 만료되며, 무료 인증 티어로 조정됩니다.",
      "⑥ 베타 기간 무상 제공되는 티어 혜택은 베타 종료 후 자동으로 만료되며, 별도 갱신하지 않는 한 무료 인증 티어로 조정됩니다.",
      "⑦ AI 기능의 일일 호출 횟수는 티어에 따라 제한되며, 관련 한도는 서비스 내에 별도로 공지합니다.",
    ],
  },
  {
    heading: "제8조 (지적재산권)",
    body: [
      "① 서비스에 게재된 정보, 디자인, 소스코드, 데이터베이스, 로고, 명칭 등 일체의 지적재산권은 회사 또는 정당한 권리자에게 귀속됩니다.",
      "② 이용자는 회사의 사전 서면 동의 없이 서비스에서 취득한 정보를 복제, 전송, 출판, 배포, 2차 가공하여 상업적으로 이용할 수 없습니다.",
      "③ 이용자가 커뮤니티에 게시한 콘텐츠의 저작권은 해당 이용자에게 귀속되나, 회사는 서비스 운영·홍보·통계 분석을 위해 이를 비독점적으로 사용할 수 있는 권리를 가집니다.",
    ],
  },
  {
    heading: "제9조 (이용 제한 조치)",
    body: [
      "① 회사는 이용자가 이 약관을 위반하거나 서비스 운영에 중대한 지장을 초래한 경우, 사전 통지 없이 경고·일시정지·영구이용정지 등의 조치를 취할 수 있습니다.",
      "② 위반 사항이 형사처벌 대상인 경우 수사기관에 수사의뢰 또는 고발할 수 있습니다.",
    ],
  },
  {
    heading: "제10조 (면책조항)",
    body: [
      "① 회사는 수집·정제된 트렌드 정보를 객관적 데이터 기반으로 제공하되, 이를 활용한 이용자의 메뉴 개발·창업·투자 등 의사결정 결과에 대해 어떠한 보증도 하지 않으며 책임을 지지 않습니다.",
      "② 회사는 천재지변, 전쟁, 제3자 서비스 장애, 해킹 등 회사의 귀책사유가 없는 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.",
      "③ 커뮤니티에 게시된 이용자 간 의견·후기의 신뢰성, 정확성에 대해 회사는 일체의 책임을 지지 않습니다.",
    ],
  },
  {
    heading: "제11조 (분쟁 해결 및 관할 법원)",
    body: [
      "① 이 약관의 해석 및 이용자와 회사 간 분쟁은 대한민국 법령에 따릅니다.",
      "② 서비스 이용과 관련하여 분쟁이 발생한 경우, 쌍방은 상호 협의하여 원만히 해결하도록 노력하며, 협의가 이루어지지 않을 경우 민사소송법상의 관할 법원을 제1심 관할로 합니다.",
    ],
  },
  {
    heading: "제12조 (외부 API 서비스 이용 동의 — YouTube API Services)",
    body: [
      "① 회사는 트렌드 분석 및 레시피 연계 기능을 제공하기 위해 YouTube API Services 를 이용합니다.",
      "② 이용자는 본 서비스를 이용함으로써 YouTube 이용약관(https://www.youtube.com/t/terms)에 동의하며, 해당 약관의 적용을 받습니다.",
      "③ 회사는 YouTube API Services 를 통해 취득한 공개 콘텐츠 메타데이터(영상 제목·설명·통계 등)만을 본 약관 및 개인정보처리방침에서 정한 범위 내에서 처리하며, YouTube 사용자 인증(OAuth) 기반 개인 데이터는 별도 동의 없이 수집·이용하지 않습니다.",
      "④ YouTube API Services 이용과 관련한 Google 의 개인정보 처리 방침은 https://policies.google.com/privacy 에서 확인하실 수 있습니다.",
    ],
  },
  {
    heading: "부칙",
    body: [
      "① 이 약관은 2026년 4월 23일부터 시행됩니다.",
      "② 본 개정 약관(YouTube API Services 이용 동의 조항 추가)은 2026년 5월 30일부터 시행됩니다.",
    ],
  },
];

export default function TermsPage() {
  return (
    <div className="pb-24">
      {/* 헤더 */}
      <div className="sticky top-0 z-40 bg-bg/90 backdrop-blur-md border-b border-border px-4 py-3 flex items-center gap-3">
        <Link href="/mypage" className="text-text-sub hover:text-text transition-colors">
          ←
        </Link>
        <h1 className="text-base font-black text-text">이용약관</h1>
      </div>

      {/* 시행일 */}
      <div className="px-4 mt-4">
        <p className="text-xs text-text-sub">시행일: {EFFECTIVE_DATE}</p>
      </div>

      {/* 약관 본문 */}
      <div className="px-4 mt-3 space-y-5">
        {ARTICLES.map((art) => (
          <section key={art.heading} className="card">
            <h2 className="text-sm font-bold text-text mb-2">{art.heading}</h2>
            <div className="space-y-2">
              {art.body.map((line, i) => (
                <p
                  key={i}
                  className="text-[12px] text-text-sub leading-relaxed whitespace-pre-wrap"
                >
                  {line}
                </p>
              ))}
            </div>
          </section>
        ))}

        <CompanyInfo />

        <p className="text-2xs text-text-sub text-center pt-2">
          본 약관은 관련 법령 및 서비스 변경에 따라 갱신될 수 있으며, 갱신 시 시행일 전 공지됩니다.
        </p>
      </div>
    </div>
  );
}
